(ns dashboard.views.answer-bank.events
  (:require [re-frame.core :as rf]
            [dashboard.services.http-config :as http-config]
            [dashboard.components.paginated-list.events :as paginated-list-events]
            [dashboard.ui :as ui]
            [dashboard.notifications :as notifications]
            [dashboard.components.confirm-delete-question-answer-modal :refer [confirm-delete-question-answer-modal]]
            [clojure.string :as str]))

(rf/reg-event-fx
  ::get-answer-bank
  (fn [{:keys [db]}]
    {:db (assoc-in db [:answer-bank :loading] true)
     :http-xhrio {:method :get
                  :uri "/api/answer-bank"
                  :response-format http-config/transit-response-format
                  :on-success [::get-answer-bank-success]
                  :on-failure [::get-answer-bank-failure]}}))

(rf/reg-event-fx
  ::get-answer-bank-success
  (fn [{:keys [db]} [_ items]]
    {:db (assoc db :answer-bank {:loading false
                                 :data items})}))

(rf/reg-event-fx
  ::get-answer-bank-failure
  (fn [{:keys [db]} _]
    {:db (assoc-in db [:answer-bank :loading] false)
     :dispatch [::ui/set-error "Could not get answer bank items"]}))

(rf/reg-event-fx
 ::create-answer
 (fn [_ [_ view-config-path {:keys [question response comment analysis]}]]
   {:dispatch [::paginated-list-events/update-state {:view-config-path view-config-path
                                                     :updates {:editable-row-saving? true}}]
    :http-xhrio {:method :post
                 :uri "/api/answer-bank"
                 :params (cond-> {:question (some-> question str/trim)
                                  :response (some-> response str/trim)
                                  :comment (some-> comment str/trim)}
                           (not (some-> analysis str/trim str/blank?)) (assoc :analysis (some-> analysis str/trim)))
                 :format http-config/transit-request-format
                 :response-format http-config/transit-response-format
                 :on-success [::create-answer-success view-config-path]
                 :on-failure [::create-answer-failure view-config-path]}}))

(rf/reg-event-fx
 ::create-answer-success
 (fn [{:keys [db]} [_ view-config-path item]]
   {:db (update-in db [:answer-bank :data] conj item)
    :fx [[:dispatch [::paginated-list-events/update-state {:view-config-path view-config-path
                                                           :updates {:editable-row nil
                                                                     :editable-row-saving? false}}]]
         [:dispatch [::notifications/add {:message "Question / answer added to the answer bank"
                                          :class "is-success"}]]]}))

(rf/reg-event-fx
 ::create-answer-failure
 (fn [_ [_ view-config-path]]
   {:fx [[:dispatch [::paginated-list-events/update-state {:view-config-path view-config-path
                                                           :updates {:editable-row-saving? false}}]]
         [:dispatch [::notifications/add {:message "Could not add question / answer into the answer bank"
                                          :class ["is-danger" "has-text-white"]}]]]}))

(rf/reg-event-fx
 ::try-delete-question-answer
 (fn [_ [_ question-id]]
   {:dispatch [::ui/push-modal
               {:ctx       question-id
                :component (confirm-delete-question-answer-modal {:on-confirm #(rf/dispatch [::delete-question-answer question-id])})}]}))

(rf/reg-event-fx
 ::delete-question-answer
 (fn [_ [_ question-id]]
   {:http-xhrio {:method :delete
                 :uri (str "/api/answer-bank/questions/" question-id)
                 :format http-config/transit-request-format
                 :response-format http-config/transit-response-format
                 :on-success [::delete-question-answer-success question-id]
                 :on-failure [::delete-question-answer-failure]}}))

(rf/reg-event-fx
 ::delete-question-answer-success
 (fn [{:keys [db]} [_ question-id]]
   {:db (update-in db [:answer-bank :data] (fn [items]
                                             (remove (fn [item]
                                                       (= (:question-id item) question-id))
                                                     items)))
    :dispatch [::notifications/add {:message "Question / answer removed"
                                    :class "is-success"}]}))
(rf/reg-event-fx
 ::delete-question-answer-failure
 (fn [_ [_]]
   {:dispatch [::notifications/add {:message "Could not remove question / answer"
                                    :class ["is-danger" "has-text-white"]}]}))
